var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFixedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70416 7.12364L9.87791 4.94764C9.9774 4.8489 10.0194 4.70641 9.99155 4.56893C9.96324 4.43185 9.86792 4.31771 9.73763 4.26605C8.2628 3.67737 7.14596 3.80485 6.67267 3.90693L4.04642 1.6705C4.09846 0.785601 3.62308 0.182758 3.60101 0.155261C3.52733 0.0631818 3.41744 0.00693808 3.29921 0.000278674C3.18223 -0.00388102 3.06568 0.0386142 2.98242 0.121925L0.121872 2.98494C0.0377926 3.06869 -0.00634465 3.18492 0.000738384 3.30366C0.00739215 3.42199 0.0644272 3.53238 0.157677 3.60571C0.668846 4.01233 1.30782 4.05525 1.64709 4.04651L3.90158 6.69871C3.81957 7.17282 3.71385 8.33561 4.27163 9.73753C4.32325 9.86792 4.43689 9.96291 4.57384 9.99166C4.60216 9.99707 4.63004 10 4.65792 10C4.76741 10 4.87356 9.95709 4.95223 9.87792L7.11556 7.71275L9.27848 9.87792C9.35966 9.95916 9.46621 10 9.57279 10C9.67935 10 9.78593 9.95916 9.8671 9.87792C10.0299 9.71503 10.0299 9.45172 9.8671 9.28883L7.70416 7.12364Z",
    fill: "#000000"
  })));
}

export default SvgFixedIcon;